import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'

const FullScreenLayout = compose(
  connect(state => {
    return {
      config: state.config
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.dispatch({
        type: 'SET_CONFIG',
        config: { layout: 'fullScreen-layout' }
      })
    }
  })
)

export default FullScreenLayout
